import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IhmPipesModule } from '../../shared/pipes/ihm-pipes.module';
import { IhmWarningMessageComponent } from './ihm-warning-message.component';

@NgModule({
  imports: [
    CommonModule,
    // Material Module
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    IhmPipesModule
  ],
  declarations: [IhmWarningMessageComponent],
  exports: [IhmWarningMessageComponent]
})
export class IhmWarningMessageModule {}
